import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import CartReducer from './features/CartReducer';
import UserAuthReducer from './features/UserAuthReducer';

const store = configureStore({
  reducer: {
    initialCart: CartReducer,
    isLogin: UserAuthReducer,
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
